<template>
  <v-flex 
    md12 
    class="flex_container">
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex 
            xs3 
            md2>
            <div>
              <dl>
                <dd class="caption">{{ $t("from_date") }}</dd>
                <dt>{{ school.from }}</dt>
                <dd class="caption">{{ $t("to_date") }}</dd>
                <dt>{{ school.to }}</dt>
              </dl>
            </div>
                
          </v-flex>
          <v-flex 
            xs9 
            md10>
            <p class="title">{{ school.school }}</p>
            <p class="subheading">{{ school.degree }}</p>
            <p><span class="body-2">{{ $t("skills_gained") }}:</span>

              <ul class="normal-list">
                <li 
                  v-for="skill in school.skills" 
                  :key="skill.id">{{ skill.text }}</li>
            </ul></p>
            <p v-if="school.notes !== undefined"><span class="body-2">{{ $t("notes") }}:</span><br >
              {{ school.notes }}</p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<style lang="scss" scoped>
.flex_container {
  page-break-inside: avoid;
  break-inside: avoid;
}
</style>

<script>
export default {
    name: 'EducationItem',
    props: {
        school: {
          type: Object,
          default: null
        }
    },
    data () {
        return {
        }
    }
}
</script>